import React, { useState, useEffect, useRef } from 'react';
import './styles.css'; // Import your CSS file
import VerticalInputText from "./VerticalInputText";
//import '@fontawesome/fontawesome-free/css/all.css';
import LocationFetcher from './LocationFetcher';

import ReactDOM from 'react-dom';
import ReactStars from "react-rating-stars-component";
//import RatingComponent from "./RatingComponent";
//import UserAuthComponent from './UserAuthComponent';
//import L from 'leaflet';
//import 'leaflet/dist/leaflet.css';

import SongMetadataEditor, { SongDataProvider, useUpdateSongData } from './SongMetadataEditor';
import SongSaveEditor, { SongSaveDataProvider, useUpdateSongSaveData } from './SongSaveEditor';
import PlaylistFilter from './PlaylistFilter';
import { del } from 'aws-amplify/api';

/*
//Component LibraryTags
function LibraryTags({ options }) {
    const [tags, setTags] = useState([]);

    {
        Object.entries(addedTags).map(([tag, name]) => (
            <div
                onClick={() => { onSelect(tag) }}
                className="tag-box" style={{
                    fontSize: "2.2em",
                    backgroundColor: (libraryTags) ? "cornflowerblue" : "lightgrey", borderRadius: 5, borderWidth: 3, borderColor: "grey", margin: "40", padding: "40"
                }} >
                <span style={{ color: (selected) ? "black" : "white" }}>{" " + name + " "}</span>
                {(selected) ? <button className="tag-delete" style={{}} onClick={() => { }}>×</button> : <button className="tag-add" onClick={() => { onSelect(tag) }}>+</button>}
            </div>
        ))
    };
}
*/





/** to move */

const standaloneCountries = {
    "Q16": "Canada",
    "Q17": "Japan",
    "Q29": "Australia",
    "Q30": "USA", //1M
    "Q34": "Belgium",
    "Q36": "Sweden",
    "Q38": "Italy",
    "Q55": "Mexico",
    "Q96": "Netherlands", //10K
    "Q142": "France", //10K
    "Q145": "UK", //100K
    "Q183": "Germany", //10K
}
const COUNTRIES = ["Q258", "Q262", "Q265", "Q298", "Q334", "Q347", "Q398", "Q399", "Q408", "Q414", "Q423", "Q424", "Q574", "Q657", "Q664", "Q668", "Q672", "Q683", "Q686", "Q685", "Q691", "Q695", "Q697", "Q702", "Q711", "Q712", "Q717", "Q734", "Q733", "Q739", "Q736", "Q750", "Q754", "Q757", "Q763", "Q760", "Q766", "Q769", "Q774", "Q778", "Q783", "Q781", "Q786", "Q784", "Q792", "Q16", "Q17", "Q20", "Q27", "Q30", "Q31", "Q28", "Q29", "Q34", "Q35", "Q32", "Q33", "Q38", "Q39", "Q36", "Q37", "Q43", "Q40", "Q41", "Q45", "Q55", "Q79", "Q77", "Q96", "Q114", "Q115", "Q117", "Q142", "Q145", "Q148", "Q155", "Q159", "Q183", "Q184", "Q191", "Q189", "Q211", "Q214", "Q215", "Q213", "Q218", "Q219", "Q222", "Q221", "Q227", "Q224", "Q225", "Q228", "Q229", "Q232", "Q233", "Q236", "Q237", "Q241", "Q252", "Q219060", "Q756617", "Q16112782", "Q124153644", "Q794", "Q796", "Q800", "Q801", "Q805", "Q810", "Q811", "Q813", "Q819", "Q822", "Q826", "Q833", "Q836", "Q837", "Q842", "Q843", "Q846", "Q851", "Q854", "Q858", "Q863", "Q865", "Q869", "Q874", "Q878", "Q881", "Q884", "Q889", "Q902", "Q912", "Q916", "Q917", "Q921", "Q924", "Q928", "Q929", "Q945", "Q948", "Q954", "Q953", "Q958", "Q962", "Q963", "Q967", "Q965", "Q970", "Q971", "Q974", "Q977", "Q986", "Q1000", "Q1006", "Q1005", "Q1011", "Q1008", "Q1009", "Q1014", "Q1013", "Q1016", "Q1020", "Q1027", "Q1025", "Q1030", "Q1028", "Q1032", "Q1033", "Q1039", "Q1036", "Q1037", "Q1042", "Q1041", "Q1044", "Q1045", "Q1049", "Q1246", "Q21203", "Q26273", "Q26988", "Q29999", "Q34020", "Q488889", "Q131839713", "Q804", "Q817", "Q983", "Q1007", "Q1019", "Q1029", "Q1050", "Q43287", "Q403", "Q419", "Q678", "Q710", "Q709", "Q730", "Q790", "Q212", "Q217", "Q230", "Q235", "Q238", "Q242", "Q244"]
const standaloneMetaGenres = { "m3": true, "m12": true, "m13": true, "m18": true, "m23": true, "m24": true, "m31": true };
//deepdive only accepts one genre and/or one location at a time
//if there is a location
// locationNum = locationId without "Q" prefix
// if locationId in standaloneCountries, then pack is "pageData__" + locationId + "_0-2025_xxx.json"
// else if locationNum < 100, then pack is "pageData__Q100minus_0-2025_xxx.json"
// else if locationNum between 100 and 200, then pack is "pageData__Q100-200_0-2025_xxx.json"
// else if locationNum between 200 and 500, then pack is "pageData__Q200-500_0-2025_xxx.json"
// else if locationNum between 500 and 900, then pack is "pageData__Q500-1000_0-2025_xxx.json"
// else pack is "pageData__Q900plus_0-2025_xxx.json"
// else if there is a genre
// if it is a metagenre, 
// then if it is in standaloneMetaGenres, then pack is "pageData_" + genreId + "_0-2025_xxx.json"
// else if it is not a metagenre, then pack is "pageData__Q100minus_0-2025_xxx.json"


const someRock = {
    "4128": "Piano Rock",
    "3042": "Space Rock",
    "3027": "Stoner Rock",
    "2443": "Glam Rock",
    "3066": "Math Rock",
    "3099": "Industrial Rock",
    "3475": "Garage Rock",
    "2621": "Synth Rock",
    "3072": "Gothic Rock",
    "3936": "Soft Rock",
    "2383": "Noise Rock",
    "2037": "Post-Rock",
    "2394": "Experimental Rock",
    "2382": "Art Rock",
    "2354": "Electronic Rock",
    "1589": "New Wave (Rock)",
    "2740": "Psychedelic Rock",
    "2362": "Progressive Rock",
    "2357": "Hard Rock",
    "1312": "Alternative Rock",
    "1506": "Indie Rock",
    "2411": "Shoegaze",
    "3364": "Screamo"
}

const somePop = {
    "4347": "Progressive Pop",
    "4502": "Arabic Pop - بوب عربي",
    "4317": "Ambient Pop",
    "4057": "Chamber Pop",
    "3047": "Noise Pop",
    "2475": "Bubblegum Pop",
    "4316": "Pop-R&B",
    "2788": "Dark Pop",
    "2857": "Power Pop",
    "3479": "Country Pop",
    "3355": "Experimental Pop",
    "2455": "Scandipop",
    "2902": "Bedroom Pop",
    "2887": "Teen Pop",
    "1448": "Dream Pop",
    "3880": "Hyperpop",
    "2289": "Synth-Pop",
    "840": "Alternative Pop",
    "477": "Indie Pop",
    "964": "Pop-Rock",
    "3970": "Pop Rap",
    "2117": "Art Pop"
}


const someRap = {
    "3925": "Soul Rap",
    "3419": "Country Rap",
    "3743": "Industrial Hip-Hop",
    "3650": "Desi Hip-Hop",
    "3625": "Jazz Rap",
    "4525": "Midwest Rap",
    "2396": "Trip-Hop",
    "4412": "Alternative Rap",
    "3817": "Meme Rap",
    "3670": "Rap-Rock",
    "3884": "Abstract Rap",
    "4670": "Southern Rap",
    "3473": "Dirty South",
    "3758": "Experimental Rap",
    "1730": "Conscious Hip-Hop",
    "802": "Arabic Rap - راب عربي",
    "798": "West Coast Rap",
    "2502": "East Coast Rap",
    "3783": "Hip-Hop",
    "3598": "Underground Rap",
    "2032": "Horrorcore",
    "3187": "Chillhop",
    "2872": "Glitch Hop",
    "3155": "Phonk",
    "4105": "Rage",
    "305": "Spoken Word",
    "2964": "Lo-Fi",
    "4174": "Contemporary R&B"

}

const someAlternative = {
    "2757": "Alternative",
    "2758": "Adult Alternative",
    "3036": "Alternative Country",
    "2963": "Independent",
    "2381": "Experimental",
    "2855": "Industrial",
    "2395": "IDM",
}

const someOthers = {
    "2094": "Remix",
    "2633": "Cover",
    "1615": "Acoustic",
    "290": "Live",
    "249": "Freestyle",
    "1375": "Drum & Bass",
    "2326": "Adult Contemporary",
    "3043": "Neo-Psychedelia",
    "3117": "Bass Music",
    "3463": "Plugg",
    "1492": "Grunge",
    "2965": "Post-Grunge",
    "2853": "LGBTQ+",
    "2390": "Melodic Hardcore",
    "3049": "Americana",
    "4231": "Duet",
    "2883": "Unreleased",
    "3297": "Dark Ambient",
    "3165": "Dark Wave",
    "3101": "Avant Garde",
    "3118": "Noise",
    "3048": "Slowcore",
    "3876": "PluggnB",
    "2777": "Psychedelic",
    "3939": "K-Japanese",
    "3172": "Soul Jazz",
    "2891": "Breakbeat",
    "3019": "Mashup",
    "3379": " हिंदी (Hindi)",
    "2733": "Sertanejo",
    "2968": "Drone",
    "952": "A Cappella",
    "3499": "Filk",
    "18": "Poetry",
    "2819": "Vocaloid",
    "2477": "Bluegrass",
    "2842": "Grindcore",
    "2361": "Rockabilly",
    "2899": "Chiptune",
    "3992": "VTuber",
    "3362": "Mathcore",
    "1268": "New Jack Swing",
}

let excludedTags = {
    "4771": "In English",
    "2586": "En EspaÃ±ol",
    "4790": "Auf Deutsch",
    "2945": "Em PortuguÃªs",
    "3041": "Singer-Songwriter",
    "1472": "Korean (í•œêµ­ì–´)",
    "3930": "South Korea (ëŒ€í•œë¯¼êµ­)", //ToDo: fix, should link to Korea Q884 (link South Korea to it?)
}


const gettheRightPack = (locationId, genreId) => {
    console.log("Determining pack for locationId:*", locationId, "*and genreId:", genreId);
    let pack = "";
    if (locationId) {
        let locationNum = parseInt(locationId.replace("Q", ""));
        if (standaloneCountries[locationId])
            pack = "pageData__" + locationId + "_0-2025_xxx.json";
        else if (locationId == "Q962") //Benin
            pack = "pageData__Q962_0-2025_xxx.json";
        else if (locationNum < 100)
            pack = "pageData__Q100minus_0-2025_xxx.json";
        else if (locationNum >= 100 && locationNum < 200)
            pack = "pageData__Q100-200_0-2025_xxx.json";
        else if (locationNum >= 200 && locationNum < 500)
            pack = "pageData__Q200-500_0-2025_xxx.json";
        else if (locationNum >= 500 && locationNum < 900)
            pack = "pageData__Q500-900_0-2025_xxx.json";
        else
            pack = "pageData__Q900plus_0-2025_xxx.json";

        if (locationId == "Q30" && (genreId == "16" || genreId == "1434" || genreId == "567"))
            pack = "pageData_" + genreId + "_" + locationId + "_0-2025_xxx.json";
    }
    else if (genreId) {
        if (standaloneMetaGenres[genreId])
            pack = "pageData_" + genreId + "__0-2025_xxx.json";
        else if (genreId.indexOf("m") == 0) {
            let genreNum = parseInt(genreId.replace("m", ""));
            if (genreNum <= 10)
                pack = "pageData_m1-10__0-2025_xxx.json";
            else if (genreNum <= 20)
                pack = "pageData_m11-20__0-2025_xxx.json";
            else if (genreNum <= 30)
                pack = "pageData_m21-30__0-2025_xxx.json";
            else
                pack = "pageData_m32-48__0-2025_xxx.json";
        }
        else { //all genres
            let mainGenres = { "16": true, "352": true, "413": true, "567": true, "1434": true };
            if (genreId in mainGenres) {
                if (genreId == "352" || genreId == "413")
                    pack = "pageData_" + genreId + "__0-2025_xxx.json";
                else if (!locationId)
                    pack = "";
            }
            else { //all tags
                if (genreId in someRock)
                    pack = "pageData_sRock__0-2025_xxx.json";
                else if (genreId in somePop)
                    pack = "pageData_sPop__0-2025_xxx.json";
                else if (genreId in someRap)
                    pack = "pageData_sRap__0-2025_xxx.json";
                else if (genreId in someAlternative)
                    pack = "pageData_sAlt__0-2025_xxx.json";
                else if (genreId in someOthers)
                    pack = "pageData_sOth__0-2025_xxx.json";
                else {
                    pack = "pageData_theRest__0-2025_xxx.json"; //default
                }
            }
        }
    }

    console.log("Determined pack:", pack);
    return pack;
}






const MyPage = () => {
    const initialized = useRef(false);
    //const [page, setPage] = useState(window.location.pathname);
    const [currentSongData, setCurrentSongData] = useState({});

    const [currentSongRating, setCurrentSongRating] = useState(0);
    const [currentPack, setCurrentPack] = useState("mostpop");
    //const [currentSongFix, setCurrentSongFix] = useState("");

    const [pageLoaded, setPageLoaded] = useState(false);
    const [firstSearchDone, setFirstSearchDone] = useState(false);
    const [locationData, setLocationData] = useState({});

    let songSaveTags00 = {
  "tagtoid": {"Audio": 0, "Video": 1, "Explicit Lyrics": 2, "Explicit Video": 3, "Live": 4, "Dance Video": 5, "Instrumental": 6, "Cover": 7, "Bad Data": 8}, 
  "idtotag": {"0": "Audio", "1": "Video", "2": "Explicit Lyrics", "3": "Explicit Video",  "4": "Live", "5": "Dance Video", "6": "Instrumental", "7": "Cover", "8": "Bad Data"}
};

    const [songSaveTags, setSongSaveTags] = useState(songSaveTags00);
/*
 
*/
    const [keyLocations, setKeyLocations] = useState({
        nearby: { n: ' * NEAR ME * ', d: true },
        ny: { n: 'New York', d: true },
        la: { n: 'Los Angeles', d: true },
        london: { n: 'London', d: true },
        paris: { n: 'Paris', d: true },
        tokyo: { n: 'Tokyo', d: true },
        montreal: { n: 'Montreal', d: false },
        berlin: { n: 'Berlin', d: false },
        toronto: { n: 'Toronto', d: false },
        atlanta: { n: 'Atlanta', d: false },
        seoul: { n: 'Seoul', d: false },
    }
    );

    const [citiesIDs, setCitiesIDs] = useState({});
    const [keyTags, setKeyTags] = useState({});

    const [libraryTags, setLibraryTags] = useState({});

    const [filters, setFilters] = useState({
        mode: 'top',
        genres: [],
        genreSearch: '',
        yearRange: [-40000, 2026],
        locationSearch: '',
        locations: [],
        popularity: null,
        sortBy: 0, // 
        mapOption: "Below", // "Below", "Beside", "No Map"
        nearby: false, // true: Show nearby locations, false: Show all locations
        showSuggestions: false,
        openSteps: { 1: true, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false },
        searchText: '',
        searchType: 's'
    });

    const submitFilters = (componentFilters) => {
        console.log('PlayPage: Generating playlist with filters:', JSON.stringify(componentFilters, null, 4));
        componentFilters['searchText'] = filters.searchText;
        componentFilters['searchType'] = filters.searchType;

        let locationId = componentFilters.locations.length > 0 ? componentFilters.locations[0] : null;
        let genreId = componentFilters.genres.length > 0 ? componentFilters.genres[0] : null;

        console.log("Location ID:", locationId, "Genre ID:", genreId);
        //gettheRightPack(locationId, genreId);

        //filters = {...filters, ...componentFilters};
        //console.log("Updated filters:", JSON.stringify(filters, null
        setFilters({ ...componentFilters });
        //console.log("Filters updated:", JSON.stringify(filters, null, 4));
        submitPlayList1(componentFilters);
        //window.generatePlaylist(filters);
    };


    const handlePackChange = (newPack, shouldBuildPlaylist, componentFilters) => {
        //console.log("New Pack:", newPack);

        if (newPack == currentPack) {
            //TODO: check if gotta load something

            return; // No change in pack, do nothing^
        }

        if (newPack == "mostpop") {
            window.loadDefaultPageData(shouldBuildPlaylist);
            return;
        }
        let dataFile = "";
        if (newPack == "sample1") {
            dataFile = "/essentialsPageData.json";
        }
        else if (newPack == "rapfr") {
            dataFile = "/pageData_1434_Q142_1970-2025_xxx.json";
        }
        else if (newPack == "tests") {
            dataFile = "/pageDataToFix.json";
        }
        else if (newPack == "benin") {
            dataFile = "/pageData__Q962_0-2025_xxx.json";
        }
        else if (newPack == "special") {
            dataFile = "/packs/specialPack.json";
            console.log("Loading special pack");
        }
        else {
            dataFile = newPack;
        }


        if (dataFile == "") {
            console.log("Invalid pack selected:" + JSON.stringify(newPack));
            return;
        }
        window.loadPageData(dataFile, locationData, shouldBuildPlaylist, componentFilters);

        //updateFilter()
    }





    const handleLocationObtained = (locationData) => {
        console.log("User location:", locationData);
        setLocationData(locationData);
        window.selectPlacesNearby(locationData);

        /*
        window.loadPageData("/essentialsPageData.json");
        //navigateToNewPage("");
        //if (window.getPlaylistLength() > 0) {
        setTimeout(() => {
            setFirstSearchDone(true);
            window.selectPlacesNearby(locationData);
            window.refreshMap();
        }, 2000);

        setTimeout(() => {
            window.refreshMap();
        }, 10000);
        */


        // Perform any processing or API calls with the location data here
    };

    const updateRating = () => {
        console.log("Updating rating...");
        console.log("Current rating:", currentSongRating);
        if (typeof window.getSongRating === "function") {
            const newRating = window.getSongRating();
            console.log("New rating:", newRating);
            setCurrentSongRating(newRating);
        }
        console.log("Rating updated!");
    }

    const handleSave = (updatedData) => {
        console.log("Saved data:", updatedData);
    };

    const getCurrentSongId = () => {
        try {
            return window.getCurrentSongId();
        }
        catch (e) {
            console.log("Error getting current song ID:", e);
            return 0;
        }
        //return window.getCurrentSongId();
    };

    const handleAddTag = (entity, category, tag, uniqueValue = false) => {
        console.log(`Added tag '${tag}' to category '${category}' in '${entity}'`);
        if (entity.indexOf("artists") == 0) {
            let artistId = entity.split(".")[1];
            if (uniqueValue) {
                //replace any existing tag/value in the same category for this artist by the new one
                let existingTags = document.getElementById("editedSong").innerHTML.split("|");
                let newTags = [];
                for (let i = 0; i < existingTags.length; i++) {
                    let t = existingTags[i];
                    if (t.indexOf(artistId + ":" + category + ":") == 0) {
                        //this is a tag in the same category for the same artist, skip it
                    }
                    else {
                        newTags.push(t);
                    }
                }
                newTags.push(artistId + ":" + category + ":a:" + tag);
                document.getElementById("editedSong").innerHTML = newTags.join("|") + "|";
            }
            else document.getElementById("editedSong").innerHTML += artistId + ":" + category + ":a:" + tag + "|";
        }
        else
            document.getElementById("editedSong").innerHTML += category + ":a:" + tag + "|";
    };

    const handleDeleteTag = (entity, category, tag) => {
        console.log(`Deleted tag '${tag}' from category '${category}' in '${entity}'`);
        if (entity.indexOf("artists") == 0) {
            let artistId = entity.split(".")[1];
            document.getElementById("editedSong").innerHTML += artistId + ":" + category + ":d:" + tag + "|";
        }
        else
            document.getElementById("editedSong").innerHTML += category + ":d:" + tag + "|";
    };

    const handleAdvancedSave = (songSaveData) => {
        //console.log(`Added tag '${tag}' to category '${category}' in '${entity}'`);
        //document.getElementById("editedSongSave").innerHTML = serializedData;
        //let actualData = JSON.parse(serializedData);
        console.log("Advanced save data:", JSON.stringify(songSaveData, null, 4));
        window.rateSong(-1, { "tags": songSaveData.tags, "options": songSaveData.options }, songSaveData.startTime, songSaveData.endTime);

    };

    const getCurrentVideoTimeStamp = () => {
        let timeStamp = window.getCurrentTimeStamp();
        console.log("Current timestamp:", timeStamp);
        return timeStamp;
    }

    const loopVideo = (start, end) => {
        console.log(`Looping video from ${start} to ${end}`);
        window.loopVideoBetween(start, end);
    }

    const stopLoopVideo = () => {
        console.log("Stopping video loop");
        window.stopLooping();
    }
    /*
        const advancedSave = () => {
            let serializedData = document.getElementById("editedSongSave").innerHTML;
            let actualData = JSON.parse(serializedData);
            console.log("Advanced save data:", JSON.stringify(actualData, null, 4));
        };
    */
    useEffect(() => {
        //console.log("\n\n\nPlayPage mounted!!\n\n\n");
        const loadCSS = (href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        };

        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.async = true;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        };

        //window.history.pushState({}, '', '/loading');
        const handleBackButton = (event) => {
            // Your custom logic here
            //setFirstSearchDone(false);
            //setPage(window.location.pathname); 
            console.log("User attempted to navigate back");
            //setPage(window.location.pathname);
            setFirstSearchDone(false);
        };

        // Attach event listener
        window.addEventListener('popstate', handleBackButton);

        // Ensure the initial state is pushed only once
        if (!initialized.current) {
            //window.history.replaceState({}, '', window.location.pathname);
            initialized.current = true;
        }

        // Load CSS libraries
        loadCSS("https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.css");
        loadCSS("https://unpkg.com/leaflet/dist/leaflet.css");
        loadCSS("https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.6.1/nouislider.min.css");
        loadCSS("/Control.FullScreen.css");

        // Load Y.js and Z.js before X.js
        Promise.all([
            loadScript("/citiesIDs.js"),
            loadScript("/metagenres.js"),
            loadScript("/filterHelper.js"),
            loadScript("/allGenres.js"),
            loadScript("/allLocations.js"),
            loadScript("/allStyles.js"),
            loadScript("/allTags.js"),
            loadScript("/locationHierarchy.js"),
            loadScript("/pageData.js"),
            loadScript("/ttData.js"),
            loadScript("/fixes.js"),
            loadScript("https://code.jquery.com/jquery-3.5.1.min.js"),
            loadScript("https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.6.1/nouislider.min.js"),
            loadScript("https://unpkg.com/leaflet/dist/leaflet.js"),
            loadScript("https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.min.js"),
            loadScript("/Control.FullScreen.js"),
            loadScript("/utils.js"),
            loadScript("/storage.js")
        ])
            .then(() => {
                Promise.all([
                    loadScript("/data.js"),
                    loadScript("/mainScreen.js"),
                    loadScript("/videoPlayer.js")
                ])
                    .then(() => loadScript("/launch.js")) // Load X.js after Y.js and Z.js // old: genius.js
                    .then(() => {
                        console.log("All scripts loaded successfully");

                        //window.toastr.success("Libraries are ready!");
                        window.setExternalRating(window.getSongRating());

                        setPageLoaded(true);
                        setKeyLocations(window.getKeyPlaces());
                        setKeyTags(window.getKeyTags());
                        setCitiesIDs(window.getCitiesIDs(window.getCitiesIDs()));

                        setSongSaveTags(window.getSongSaveTags());
                        setTimeout(() => {
                            //window.loadFirstSearch();
                            //setFirstSearchDone(true);
                        }, 5000);



                    })
            })
            .catch((err) => {
                console.error("Error loading scripts:", err);
            });


        // Cleanup on component unmount
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    /*
    useEffect(() => {
        if (!currentPack) return;
        handlePackChange(currentPack, false);
        //setLoading(true);
        loadFile(formValues.fileKey)
            .then(data => {
                setRawData(data);
            })
            .finally(() => setLoading(false));
    }, [currentPack]);
*/

    const submitPlayList1 = (componentFilters) => {

        /*
        setCurrentPack(evt.target.value);
        handlePackChange(evt.target.value);
        */

        //
        //if (filters.genres.length>0){
        if (componentFilters.mode == "top" && componentFilters.yearRange[1] > 9999 && currentPack != "special") {
            handlePackChange("special", true, componentFilters);
            setCurrentPack("special");
        }
        else if (componentFilters.mode == "top+" && currentPack != "sample1") {
            handlePackChange("sample1", true, componentFilters);
            setCurrentPack("sample1");
        }
        else if (componentFilters.mode == "top" && currentPack != "mostpop") {
            handlePackChange("mostpop", true, componentFilters);
            setCurrentPack("mostpop");
        }
        else if (componentFilters.mode == "deep") {
            //console.log("Deep dive mode selected");
            let locationId = componentFilters.locations.length > 0 ? componentFilters.locations[0] : null;
            let genreId = componentFilters.genres.length > 0 ? componentFilters.genres[0] : null;
            let pack = "/packs/" + gettheRightPack(locationId, genreId);
            console.log("Pack determined:", pack);
            if (pack != currentPack) {
                handlePackChange(pack, true, componentFilters);
                setCurrentPack(pack);
            }
        }


        if (!firstSearchDone) {
            window.applyFirstSearch(componentFilters, locationData);
            //navigateToNewPage("");
            if (window.getPlaylistLength() > 0) {

                setTimeout(() => {
                    setFirstSearchDone(true);
                    window.refreshMap();

                }, 1000);

                setTimeout(() => {
                    window.refreshMap();
                }, 10000);

            }
        }
        else {
            //console.log("Submitting playlist with filters:", JSON.stringify(componentFilters, null, 4));
            window.updateFilter(componentFilters);
            //window.generatePlaylist(componentFilters, locationData);
            //window.refreshMap();
            //navigateToNewPage("");
        }


    }



    const navigateToNewPage = (page) => {
        //setPage("/" + page);
        //window.history.pushState({}, '', '/' + page);
        console.log("Navigated to a new page");
    };
    //const [skimLength, setValue] = useState("30");

    const handleSkimLength = (newValue) => {
        window.setSkimLength(newValue);
    };

    const handleStartTime = (newValue) => {
        window.setStartTime(newValue);
    };



    const setGlobalUpdateFunction = useUpdateSongData();
    const setGlobalUpdateSaveFunction = useUpdateSongSaveData();

    useEffect(() => {
        // Expose the update function to the global scope
        window.updateSongData = setGlobalUpdateFunction;
        window.updateSongSaveData = setGlobalUpdateSaveFunction;
        return () => {
            delete window.updateSongData; // Cleanup on unmount
            delete window.updateSongSaveData;
        };
    }, [setGlobalUpdateFunction, setGlobalUpdateSaveFunction]);


    return (
        <div id="app0"
            style={{ "flex": "none", flexDirection: "column", flex: "1" }}
        >
            {/*<p>Current page: {page}</p>*/}

            <div id="loading" style={{
                display: (pageLoaded && firstSearchDone) ? "none" : "flex", flexDirection: "column", flex: "1",
                justifyContent: "center", alignItems: "center", //textAlign: "center" 
            }}>

                <br></br>
                <div style={{ textAlign: "center" }}>
                    <div class="form-card" style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 5, paddingTop: 10, backgroundColor: "rgba(224, 209, 209, 0.8)" }}>
                        <h1>The more you like music,<br></br>the more music you like.</h1>
                        {/*
                        <div class="form-group">
                            <div style={{ fontSize: 27 }}>Track Music through space and time!<br />
                            
                                Fast Explore: a new song every Tick!<br />
                                This is a proof-of-concept. More soon!<br />
                                
                            </div>
                        </div>
                        */}
                    </div>
                </div>
                <br></br>
                <div class="form-card">
                    {/*
                    <h1 style={{fontSize:"3rem"}}>The playlist you want</h1>
                    */}

                    <div id="filterComponent">
                        <PlaylistFilter componentId="plf1" keyLocations={keyLocations} citiesIDs={citiesIDs} keyTags={keyTags} savedState={filters} submit={submitFilters}></PlaylistFilter>
                    </div>


                    {/*
                    <div class="form-group">
                        <label for="pack">Pack</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <select value={currentPack}
                                style={{ padding: "5px 5px", fontSize: "30px", width: "600px" }}
                                name="packOptions"
                                id="packOptions"
                                onChange={(evt) => {
                                    setCurrentPack(evt.target.value);
                                    handlePackChange(evt.target.value);
                                }
                                }
                            ><option value="mostpop">Default | Most Popular (20K+ songs)</option>
                                <option value="sample1">Sample | Balanced (95K+ songs) </option>
                                <option value="rapfr">All French Rap (70K+ songs)</option>
                                <option value="benin">Benin (400+ songs)</option>
                                <option value="tests">Tests</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="genre">Genre(s) or Theme(s)</label>
                        <select
                            style={{
                                padding: "5px 5px",
                                fontSize: "35px",
                                width: "600px",
                                //height: "12%",
                            }}
                            name="genreOptions0"
                            id="genreOptions0"
                            size="5"
                            multiple
                        ></select>
                    </div>
                    <div class="form-group">
                        <label for="years">Year(s)</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <input
                                style={{ fontSize: "30px", width: "250px" }}
                                type="text"
                                id="minYear0"
                                placeholder='From:'
                                defaultValue=""
                            />
                            <span style={{ fontSize: "40px" }}>{" "}-{" "}</span>
                            <input
                                style={{ fontSize: "30px", width: "250px" }}
                                type="text"
                                id="maxYear0"
                                placeholder='To:'
                                defaultValue=""
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="location">Location(s)</label>
                        <div style={{ padding: "0px 0px", fontSize: "0.8em", borderWidth: 0, display: "flex", flexDirection: "row" }}                                    >
                            
                            <LocationFetcher onLocationObtained={handleLocationObtained} />
                        </div>
                        <div style={{ padding: "5px 5px", fontSize: "1.1em", borderWidth: 0, display: "flex", flexDirection: "column" }}  >
                            <label for="notnearyou"> Countries </label>
                            <select
                                style={{
                                    padding: "5px 5px",
                                    fontSize: "40px",
                                    width: "600px",
                                    //height: "12%",
                                }}
                                name="locationOptions0"
                                id="locationOptions0"
                                size="5"
                                multiple
                            ></select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="sort">Sort By</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <select
                                style={{ padding: "5px 5px", fontSize: "40px", width: "320px" }}
                                name="sortOptions0"
                                id="sortOptions0"
                            //onChange={() => window.updateSort()}
                            ><option value="d">Release Date</option>
                                <option value="z">Youtube Views</option>
                                <option value="r">Youtube Views+</option>
                                <option value="c">Genius Contributors</option>
                                <option value="w">Genius Page Views</option>
                            </select>

                            <select
                                style={{ padding: "5px 5px", fontSize: "40px", width: "280px" }}
                                name="sortOptionsDir0"
                                id="sortOptionsDir0"
                            >
                                <option value="asc">Ascending &#8593;</option>
                                <option value="desc">Descending &#8595;</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="map">Map Options</label>
                        <select
                            style={{ padding: "5px 5px", fontSize: "40px", width: "600px" }}
                            name="mapPosition0"
                            id="mapPosition0"
                        >
                            <option value="2">Below the video</option>
                            <option value="1">Beside the video</option>
                            <option value="0">No Map</option>
                        </select>
                        <span style={{ fontSize: "30px" }} >(Select "No Map" for older devices)</span>
                    </div>

                    <button class="btn" onClick={
                        () => submitPlayList1()
                    } >
                        PLAY</button>
                    */}
                </div>

                <br></br>
                {/*

                <div class="form-card">
                    <h1>Contact us</h1>
                    
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input type="text" id="name" placeholder="Enter your name"></input>
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" placeholder="Enter your email"></input>
                    </div>
                    <div class="form-group">
                        <label for="message">Message</label>
                        <textarea id="message" placeholder="Enter your message"></textarea>
                    </div>
                    <button class="btn" onClick={() => {
                        window.sendMessage();
                    }}>
                        Send</button>
                    <br></br>
                    
                    <a style={{ fontSize: 30 }} href="https://www.reddit.com/r/TickTrack/" target="_blank" rel="noreferrer">
                        Join the discussion on Reddit
                    </a>
                    <br></br>
                </div>
                */}



                <div id="wait" style={{ display: (pageLoaded) ? "none" : "flex", flexDirection: "column", flex: "1", justifyContent: "center", alignItems: "center" }}>
                    <h1>Loading...</h1>
                </div>

            </div>

            <div id="app"
                style={{ display: (pageLoaded && firstSearchDone) ? "flex" : "none", flexDirection: "column", flex: "1" }}
            >
                <div id="tableContainer"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <table >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="container"> {/* onScroll={() => window.noScroll()}> */}
                                        <div
                                            id="iframePlayer1"
                                            style={{ order: 0, overflowX: "hidden" }}
                                            className="iframePlayer1"
                                        >
                                            <div id="player"></div>
                                        </div>
                                        <div
                                            id="iframePlayer2"
                                            style={{ order: 2, overflowX: "hidden" }}
                                            className="iframePlayer2"
                                        >
                                            <div id="player2"></div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ blackgroundColor: "white", paddingTop: "0px" }}>

                                <div id="control1" style={{
                                    //height: "100px",
                                    //width: "100%",

                                    display: "flex",
                                    flexDirection: "row",
                                    paddingTop: "0px",
                                    //alignItems: "center",
                                    //justifyContent: "center",
                                    //alignContent: "center",
                                    //backgroundColor: 'cornflowerblue'
                                    //gap: "10px", // Space between elements

                                }}>
                                    <div
                                        style={{

                                            display: "none",
                                            padding: "5px 5px",
                                            //justifyContent: "space-between",
                                            alignItems: "center",

                                            flexDirection: "column",


                                            width: "50px",
                                            //color: "#fff",
                                            //fontSize: "50px",
                                            //border: "none",
                                            //borderRadius: "5px",
                                        }}>
                                        <button
                                            id="help"
                                            style={{
                                                display: "inline-flex",
                                                padding: "0px 0px",
                                                paddingBottom: "0px",
                                                marginBottom: "20px",
                                                marginTop: "0px",
                                                backgroundColor: "darkblue",
                                                justifyContent: "center",
                                                alignItems: "center",

                                                width: "50px",
                                                //height: "55px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            textAlign="center"
                                            alignContent="center"
                                            onClick={() => window.showHelp()}
                                        >
                                            ?
                                        </button>
                                        <button
                                            id="info"
                                            style={{
                                                padding: "0px 0px",
                                                paddingBottom: "0px",
                                                backgroundColor: "darkblue",
                                                justifyContent: "center",
                                                alignItems: "center",

                                                width: "50px",
                                                //height: "55px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            textAlign="center"
                                            alignContent="center"
                                            onClick={() => window.getVideoInfo()}
                                        >
                                            i
                                        </button>
                                    </div>

                                    <div style={{
                                        display: "none",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",

                                    }}>
                                        <button
                                            id="switchStart"
                                            className="button2"
                                            style={{ padding: "2px 4px", fontSize: "40px" }}
                                            onClick={() => window.switchStartTime()}
                                        >
                                            Start
                                            <br />
                                            Time
                                        </button>
                                        <VerticalInputText onInputChange={handleStartTime} defaultValue="60" label="secs" />
                                    </div>

                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        //marginLeft: "30px",
                                        //alignItems: "center",
                                        justifyContent: "flex-end",
                                        //alignContent: "flex-end",
                                        //width: "100%",
                                        backgroundColor: "white",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",
                                        padding: "5px 5px",
                                        borderWidth: 5,
                                        borderRadius: 5,
                                        borderStyle: "solid",
                                        borderColor: "darkblue",
                                    }}
                                    >

                                        <div
                                            style={{
                                                fontSize: "50px",
                                                display: "inline-flex",
                                                flexDirection: "column",
                                                //alignItems: "center",
                                                //borderLeftWidth: "10px",
                                                //backgroundColor: "grey",
                                                width: "100%",

                                                //justifyContent: "flex-end",
                                                //alignContent: "flex-end",
                                                //alignItems: "flex-end",
                                                gap: "5px", // Space between elements
                                                margin: "0px 0px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "50px",
                                                    display: "inline-flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    paddingTop: "0px",
                                                    gap: "5px", // Space between elements
                                                }}
                                            >

                                                <button
                                                    id="skimMode"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px",
                                                        //height: "55px",
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "lightgray",
                                                        width: "130px",
                                                        color: "black",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.switchSkim()}
                                                >Tick
                                                </button>
                                                <VerticalInputText onInputChange={handleSkimLength} defaultValue="30" label="secs" />
                                            </div>


                                        </div>
                                    </div>

                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        //marginLeft: "30px",
                                        //alignItems: "center",
                                        justifyContent: "flex-end",
                                        //alignContent: "flex-end",
                                        //width: "100%",
                                        backgroundColor: "white",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",
                                        padding: "5px 5px",
                                        borderWidth: 5,
                                        borderRadius: 5,
                                        borderStyle: "solid",
                                        borderColor: "darkblue",
                                    }}
                                    >

                                        <div
                                            style={{
                                                fontSize: "50px",
                                                display: "inline-flex",
                                                flexDirection: "column",
                                                //alignItems: "center",
                                                //borderLeftWidth: "10px",
                                                //backgroundColor: "grey",
                                                width: "100%",

                                                //justifyContent: "flex-end",
                                                //alignContent: "flex-end",
                                                //alignItems: "flex-end",
                                                gap: "5px", // Space between elements
                                                margin: "0px 0px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "50px",
                                                    display: "inline-flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    paddingTop: "0px",
                                                    gap: "5px", // Space between elements
                                                }}
                                            >

                                                <button
                                                    id="back"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px", 
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "darkblue",
                                                        width: "80px",
                                                        //height: "55px",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.playNextVideo(-1)}
                                                >{"  "}
                                                    &#8249;{"  "}
                                                </button>
                                                <span id="trackNumber" style={{ fontSize: "30px" }}>
                                                    <input
                                                        style={{ fontSize: "30px", width: "3.5em" }}
                                                        type="text"
                                                        id="playlistPosition"
                                                        defaultValue="0"
                                                        onSubmit={() => {
                                                            window.setPosition();
                                                            document.activeElement.blur();
                                                        }}
                                                        onBlur={() => window.setPosition()}
                                                    />{" "}
                                                    /{" "}

                                                    <span id="playlistLength" style={{ fontSize: "30px", minWidth: "6ch", display: "inline-block", textAlign: "right" }}>
                                                        0
                                                    </span>
                                                </span>
                                                <button
                                                    id="skip"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px", 
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "darkblue",
                                                        width: "80px",
                                                        //height: "55px",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.playNextVideo()}
                                                >
                                                    {"  "}
                                                    &#8250;{"  "}
                                                </button>
                                                <button
                                                    id="shuffle"
                                                    className="button2"
                                                    style={{
                                                        padding: "10px 10px",
                                                        paddingBottom: "10px",
                                                        paddingTop: "10px",
                                                        fontSize: "30px",
                                                        backgroundColor: "darkblue",
                                                        color: "#fff",
                                                        height: "50px",
                                                        fontWeight: "bold",
                                                        //width: "100%",
                                                        //flexGrow: "1",
                                                    }}
                                                    onClick={() => window.shufflePlaylist()}
                                                >
                                                    Shuffle
                                                </button>
                                            </div>


                                        </div>
                                    </div>

                                    <div id="control2" style={{ display: "none" }}>
                                        <button
                                            id="skimMode2"
                                            className="button2"
                                            style={{ padding: "2px 4px" }}
                                            onClick={() => window.switchSkim()}
                                        >
                                            mix
                                        </button>
                                        <button
                                            id="switchStart2"
                                            className="button2"
                                            style={{ padding: "2px 4px" }}
                                            onClick={() => window.switchStartTime()}
                                        >
                                            H
                                        </button>
                                        <button
                                            id="shuffle"
                                            className="button2"
                                            style={{
                                                padding: "0px 0px",
                                                backgroundColor: "#fff",
                                            }}
                                            onClick={() => window.shufflePlaylist()}
                                        >
                                            &#128256;
                                        </button>
                                        <button
                                            id="back"
                                            style={{
                                                padding: "1px 10px",
                                                backgroundColor: "cornflowerblue",
                                                color: "#fff",
                                                fontSize: "20px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            onClick={() => window.playNextVideo(-1)}
                                        >
                                            &#8249;
                                        </button>
                                        <span id="trackNumber2" style={{ fontSize: "15px" }}>
                                            0 / 0
                                        </span>
                                        <button
                                            id="skip"
                                            style={{
                                                padding: "1px 10px",
                                                backgroundColor: "cornflowerblue",
                                                color: "#fff",
                                                fontSize: "20px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            onClick={() => window.playNextVideo()}
                                        >
                                            &#8250;
                                        </button>
                                    </div>
                                </div>
                            </tr>
                            {/* Sign up / Sign in  or Signout button depending + login data 
                        <tr>
                            <table>
                                <tr>
                            <div id="signIn" style={{ display: "flex" }}>
                                <button
                                    id="signInButton"
                                    style={{
                                        padding: "5px 5px",
                                        fontSize: "20px",
                                        borderWidth: "0px",
                                        backgroundColor: "white",
                                        color: "darkblue",
                                    }}
                                    onClick={() => window.signIn()}
                                >
                                    Sign In
                                </button>
                            </div>
                            <div id="signOut" style={{ display: "flex" }}>
                                <button
                                    id="signOutButton"
                                    style={{
                                        padding: "5px 5px",
                                        fontSize: "20px",
                                        borderWidth: "0px",
                                        backgroundColor: "white",
                                        color: "darkblue",
                                    }}
                                    onClick={() => window.signOut()}
                                >
                                    Sign Out
                                </button>
                            </div>
                            <div id="loginData" style={{ display: "none" }}>
                                <span id="loginDataText" style={{ padding: "5px 5px", fontSize: "20px" }}>
                                    ...
                                </span>
                            </div>
                            </tr>
                            </table>
                            
                        </tr>
                        */}
                            <tr>
                                <table style={{ backgroundColor: "white", width: "800px" }}>
                                    <tr style={{ padding: "5px 5px", fontSize: "48px", backgroundColor: "lightgray" }}>
                                        <td>
                                            <div id="filterTab" style={{ padding: "19px 19px", display: "flex", color: "white", backgroundColor: "darkblue" }} onClick={() => window.switchTab("filterTab")}>
                                                Explore
                                            </div>
                                        </td>
                                        <td>
                                            <div id="ratingTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => {
                                                //window.updateRating();
                                                updateRating();
                                                //setCurrentSongRating(window.getSongRating());
                                                //alert("Rating: " + window.getSongRating());
                                                //window.setExternalRating(window.getSongRating());
                                                window.switchTab("ratingTab");

                                            }
                                            }>
                                                Save
                                            </div>
                                        </td>
                                        <td>
                                            <div id="statsTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => window.switchTab("statsTab")}>
                                                Stats
                                            </div>
                                        </td>
                                        <td>
                                            <div id="libraryTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => window.switchTab("libraryTab")}>
                                                Library
                                            </div>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                        <td style={{ backgroundColor: "lightgray" }}>
                                            <div id="fixTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => {
                                                window.switchTab("fixTab");
                                            }
                                            }>
                                                <i class="fas fa-edit"></i>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </tr>
                            <div id="ratingTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "30px" }}>
                                            <div id="songToRate" style={{ padding: "5px 5px", fontSize: "25px", minWidth: "50ch" }}>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <div id="currentSongRating" class="rating-container">
                                                </div>

                                                <span id="songRating" style={{ padding: "5px 5px", fontSize: "30px" }}>
                                                    ()
                                                </span>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "center", marginLeft: "20px", marginLeft: "20px", borderWidth: "5px", borderRadius: "20px", borderColor: "darkblue" }}>
                                                    <span id="theSongStats" style={{ padding: "5px 5px", fontSize: "25px", justifyContent: "flex-end", alignItems: "center", display: "flex" }}>

                                                    </span>

                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginLeft: "20px", marginLeft: "20px", borderWidth: "5px", borderRadius: "20px", borderColor: "darkblue" }}>
                                                        <button
                                                            id="loopMixButton"
                                                            style={{
                                                                fontSize: "25px",
                                                                borderWidth: "0px",
                                                                backgroundColor: "white",
                                                                color: "darkblue",
                                                            }}
                                                            onClick={() => window.playVideoWithRandomMix()}
                                                        >
                                                            MIX: 
                                                        </button>
                                                        <button
                                                            id="loopStartButton"
                                                            style={{
                                                                fontSize: "25px",
                                                                borderWidth: "0px",
                                                                backgroundColor: "white",
                                                                color: "darkblue",
                                                            }}
                                                            onClick={() => document.getElementById("loopStart").innerHTML = Math.floor(getCurrentVideoTimeStamp())}
                                                        >
                                                            Start: 
                                                        </button>
                                                        <span id="loopStart" style={{ fontSize: "20px" }}>...</span>

                                                        <button
                                                            id="loopEndButton"
                                                            style={{
                                                                fontSize: "25px",
                                                                borderWidth: "0px",
                                                                backgroundColor: "white",
                                                                color: "darkblue",
                                                            }}
                                                            onClick={() => document.getElementById("loopEnd").innerHTML = Math.floor(getCurrentVideoTimeStamp())}
                                                        >
                                                            End:
                                                        </button>
                                                        <span id="loopEnd" style={{ fontSize: "20px" }}>...</span>
                                                        <button
                                                            id="loopButton"
                                                            style={{
                                                                fontSize: "25px",
                                                                borderWidth: "0px",
                                                                backgroundColor: "white",
                                                                color: "darkblue",
                                                            }}
                                                            onClick={() => {
                                                                if (document.getElementById("loopButton").innerHTML == "PLAY") {
                                                                    loopVideo(document.getElementById("loopStart").innerHTML, document.getElementById("loopEnd").innerHTML)
                                                                    document.getElementById("loopButton").innerHTML = "STOP";
                                                                }
                                                                else {
                                                                    stopLoopVideo();
                                                                    document.getElementById("loopButton").innerHTML = "PLAY";
                                                                }
                                                            }
                                                            }
                                                        >
                                                            PLAY
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingLeft: "10px", paddingBottom: "0px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <div style={{ padding: "5px 5px", fontSize: "40px" }}>
                                                    <button
                                                        id="advancedOptionSave"
                                                        //className="button2"
                                                        style={{
                                                            //padding: "5px 5px",
                                                            fontSize: "40px",
                                                            borderWidth: "0px",
                                                            backgroundColor: "white",
                                                            color: "darkblue",
                                                        }}
                                                        onClick={() => window.toggleAdvancedSave()}
                                                    >
                                                        <i class="fa-solid fa-angles-down"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style={{ display: "flex", flexDirection: "column", padding: "5px 5px", width: "800px", alignItems: "center", justifyContent: "center", alignContent: "center" }}>

                                            <div id="advancedSave" style={{ display: "none", marginTop: 5, marginLeft: 0, paddingLeft: 0, alignItems: "center", justifyContent: "center" }}>
                                                <div id="songSaveEditor" style={{ padding: "5px 5px", alignItems: "center", justifyContent: "center", alignContent: "center" }}>
                                                    <SongSaveEditor
                                                        key={getCurrentSongId}
                                                        onSave={handleAdvancedSave}
                                                        currentTimeStamp={getCurrentVideoTimeStamp}
                                                        onTest={loopVideo}
                                                        onStopTest={stopLoopVideo}
                                                    />
                                                    <span id="editedSongSave" style={{ display: "none" }}></span>
                                                    <br />
                                                </div>

                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="fixTable" style={{ display: "none", backgroundColor: "white", width: "800px", marginTop: 5, marginLeft: 0, paddingLeft: 0, alignItems: "center", justifyContent: "center" }}>
                                <tr>
                                    <table>
                                        <tr style={{ display: "flex", flexDirection: "column", padding: "5px 5px", alignItems: "center", justifyContent: "center", alignContent: "center" }}>
                                            <div id="songToFix" style={{ padding: "5px 5px", fontSize: "25px", }}>
                                            </div>
                                            <div class="form-card" style={{ width: "620px" }}>
                                                <div class="form-group">
                                                    <label for="fixLink">Preferred Youtube link</label>
                                                    <div id="preferredVideo" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="pVideo"
                                                            defaultValue=""
                                                            onSubmit={(text) => {
                                                                //window.updateFilter();
                                                                //window.applyVideoLinkChange(text);
                                                                //document.activeElement.blur();
                                                            }
                                                            }
                                                            onBlur={(e) => {
                                                                //window.updateFilter()
                                                                window.applyVideoLinkChange(e.target.value);
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                    <span style={{ fontSize: "30px" }} >(0 to skip the video)</span>
                                                </div>

                                                <div class="form-group">
                                                    <label for="fixLink"> Fix the release date </label>
                                                    <div id="fixDate" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedDate"
                                                            defaultValue=""
                                                            onSubmit={() => {
                                                                //window.updateFilter();
                                                                //document.activeElement.blur();
                                                            }
                                                            }
                                                            onBlur={() => {
                                                                //window.updateFilter()
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                    <span style={{ fontSize: "30px" }} >(YYYY-MM-DD)</span>
                                                </div>
                                            </div>

                                            <div class="form-card" style={{ marginTop: "20px", width: "620px" }}>
                                                <h2> Edit Video Info (Advanced Users) </h2>
                                                <div class="form-group">

                                                    <label > Number of views </label>
                                                    <div id="fixViews" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedViews"
                                                            defaultValue=""
                                                            onSubmit={() => { }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <label > Cumulative Number of Views </label>
                                                    <div id="fixViews+" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedViews+"
                                                            defaultValue=""
                                                            onSubmit={() => { }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="songMetadataEditor" style={{ padding: "5px 5px" }}>

                                                <SongMetadataEditor
                                                    key={getCurrentSongId}
                                                    onSave={handleSave}
                                                    onAddTag={handleAddTag}
                                                    onDeleteTag={handleDeleteTag}
                                                />

                                                <span id="editedSong" style={{ display: "none" }}></span>
                                                <br />
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                                    <button id="fixButton" className='button2' style={{ padding: "5px 5px", marginBottom: "40px", marginTop: "20 px", fontSize: "40px" }} onClick={() => window.fixSong()}>
                                                        Apply the fixes
                                                    </button>

                                                    <a style={{ fontSize: "10px" }} id="downloadFixData" download="tickTrack.json" type="text/json">Export my data</a>
                                                    <br />
                                                    <input type="file" id="fileInput" accept=".json,application/json,text/json"></input>
                                                    {/*
                                                    <a style={{ fontSize: "10px", color: "white" }} id="loadData"  type="text/json">Import Data (Replace all Existing Data!!)</a>
                                                    <br />
                                                    */}
                                                </div>

                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="filterTable" style={{
                                display: "flex", flexDirection: "column", backgroundColor: "white", width: "800px", alignItems: "center",
                                margin: "0px 0px", padding: "0px 0px", borderRadiusLeft: "10px", borderRadiusRight: "10px"
                            }}>
                                <tr>
                                    <div class="form-group" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%", paddingBottom: "0px", marginBottom: "0px" }}>
                                        <select
                                            style={{ padding: "5px 5px", fontSize: "40px", width: "320px", marginRight: 10 }}
                                            name="searchType"
                                            id="searchType"
                                            defaultValue="s"
                                            onChange={(e) => {
                                                let searchValue = document.getElementById("search").value;
                                                let newFilters = { ...filters, "searchType": e.target.value, "searchText": searchValue };

                                                setFilters(newFilters);
                                                if (searchValue != "")
                                                    window.updateFilter(newFilters);
                                            }}
                                        //onChange={() => window.updateSort()}
                                        ><option value="s">Songs</option>
                                            <option value="a">Artists</option>
                                            <option value="p">Places</option>
                                            <option value="g">Genres</option>
                                            <option value="y">Year(s)</option>
                                            <option value="r">Age</option>
                                            <option value="c">Career</option>
                                        </select>
                                        <input
                                            style={{ fontSize: "35px", width: "100%" }}
                                            type="text"
                                            id="search"
                                            placeholder='Search in text'
                                            defaultValue=""
                                        />
                                        <button
                                            id="searchForText"
                                            style={{
                                                fontSize: "40px",
                                                borderWidth: "0px",
                                                backgroundColor: "white",
                                                color: "darkblue",
                                            }}
                                            onClick={(e) => {

                                                let newFilters = { ...filters, "searchText": document.getElementById("search").value, "searchType": document.getElementById("searchType").value };
                                                setFilters(newFilters);
                                                window.updateFilter(newFilters);

                                            }}
                                        >
                                            GO
                                        </button>
                                    </div>


                                    {/*}
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "35px" }}>
                                            <td>
                                                <span style={{ padding: "5px 5px", }}>Genre</span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <span style={{}}>
                                                    Years
                                                </span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <span style={{}}>Sort by</span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <select
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        borderRadius: "5px",
                                                        //height: "12%",
                                                    }}
                                                    name="genreOptions"
                                                    id="genreOptions"
                                                    size="2"
                                                    onBlur={() => window.updateFilter()}
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        //document.activeElement.blur();
                                                    }
                                                    }
                                                    onChange={() => window.updateFilter()}

                                                    multiple
                                                ></select>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <input
                                                    style={{ fontSize: "35px", width: "3.2em", height: "50px", borderRadius: "5px" }}
                                                    type="text"
                                                    id="minYear"
                                                    defaultValue=""
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        document.activeElement.blur();
                                                    }
                                                    }
                                                    onBlur={() => window.updateFilter()}
                                                />
                                                <span style={{ fontSize: "35px" }}> - </span>
                                                <input
                                                    style={{ fontSize: "35px", width: "3.2em", height: "50px", borderRadius: "5px" }}
                                                    type="text"
                                                    id="maxYear"
                                                    defaultValue=""
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        document.activeElement.blur();
                                                    }
                                                    }
                                                    onBlur={() => window.updateFilter()}
                                                />
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <select
                                                    style={{ padding: "5px 5px", fontSize: "35px", borderRadius: "5px", height: "50px" }}
                                                    name="sortOptions"
                                                    id="sortOptions"
                                                    onChange={() => window.updateSort()}
                                                >
                                                    <option value="d">Date</option>
                                                    <option value="z">Views</option>
                                                    <option value="r">Views+</option>
                                                </select>
                                                <span style={{ padding: "5px 5px", fontSize: "35px", height: "45px" }}>
                                                    <button id="sortButton" className='button2' style={{ padding: "5px 5px", fontSize: "35px", fontWeight: "bold", width: "50px", backgroundColor: "darkblue", color: "white" }} onClick={() => window.changeSortDirection()}>
                                                        &#8595;
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                    */}
                                </tr>
                                <tr>
                                    <td style={{ paddingLeft: "10px", paddingBottom: "0px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <div style={{ padding: "5px 5px", fontSize: "40px" }}>
                                            <button
                                                id="advancedOption"
                                                //className="button2"
                                                style={{
                                                    //padding: "5px 5px",
                                                    fontSize: "40px",
                                                    borderWidth: "0px",
                                                    backgroundColor: "white",
                                                    color: "darkblue",
                                                }}
                                                onClick={() => window.toggleAdvanced()}
                                            >
                                                <i class="fa-solid fa-angles-down"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>



                                <div id="advancedFilters" style={{ display: "none", marginTop: 5, marginLeft: 0, paddingLeft: 0, width: "700px", alignItems: "center", justifyContent: "center" }}>

                                    <div class="form-card">
                                        <div id="filterComponent1">
                                            <PlaylistFilter componentId="plf2" keyLocations={keyLocations} citiesIDs={citiesIDs} keyTags={keyTags} savedState={filters} submit={submitFilters}></PlaylistFilter>
                                        </div>
                                    </div>

                                </div>


                            </div>
                            <div id="statsTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "30px" }}>

                                            Stats about songs watched per genre, country, and year
                                            <div id="basicStats"
                                                style={{ textAlign: "left", padding: "20px 20px", fontSize: "30px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="libraryTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "35px", paddingTop: "50px", gap: "10px" }}>
                                            <div style={{ display: "flex", flex: 1, padding: "5px 5px", flexDirection: "row", alignItems: "flex-center", justifyContent: "center" }}>
                                                <select id="libraryOperation" style={{ margin: "5px 5px", fontSize: "35px", paddingRight: "10px" }}
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> --- </option>
                                                    <option value="1"> Only </option>
                                                    <option value="2"> Include </option>
                                                    <option value="3"> Exclude </option>
                                                </select>
                                                songs rated
                                                <select
                                                    style={{ margin: "5px 5px", fontSize: "35px", paddingLeft: "10px" }}
                                                    name="ratingComparison"
                                                    id="ratingComparison"
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> any </option>
                                                    <option value="<"> less than </option>
                                                    <option value="<="> at least </option>
                                                    <option value="="> exactly </option>
                                                    <option value=">="> at most </option>
                                                    <option value=">"> more than </option>
                                                </select>
                                                <select
                                                    style={{ margin: "5px 5px", fontSize: "35px" }}
                                                    name="ratingThreshold"
                                                    id="ratingThreshold"
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> ☆☆☆☆☆ </option>
                                                    <option value="1"> ★☆☆☆☆ </option>
                                                    <option value="2"> ★★☆☆☆ </option>
                                                    <option value="3"> ★★★☆☆ </option>
                                                    <option value="4"> ★★★★☆ </option>
                                                    <option value="5"> ★★★★★ </option>
                                                </select>
                                            </div>
                                        </tr>
                                        <tr style={{ padding: "5px 5px", fontSize: "15px" }}>
                                            
                                            <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                
                                            {
                                                
                                                Object.entries(songSaveTags?.idtotag || {}).map(([tag, name]) => (
                                                    <div style={{ padding: "20px" }}>
                                                    <div
                                                        onClick={() => { 
                                                            if (tag in libraryTags) delete libraryTags[tag];
                                                            else libraryTags[tag] = 1;
                                                            setLibraryTags({ ...libraryTags });
                                                        }}
                                                        className="tag-box" style={{
                                                            fontSize: "2.2em",
                                                            backgroundColor: (tag in libraryTags) ? "cornflowerblue" : "lightgrey", borderRadius: 5, borderWidth: 3, borderColor: "grey", margin: "40", padding: "40"
                                                        }} >
                                                        <span style={{ color: (tag in libraryTags) ? "black" : "white" }}>{" " + name + " "}</span>
                                                        {(tag in libraryTags) ? <button className="tag-delete" style={{}} onClick={() => { }}>×</button> : <button className="tag-add" onClick={() => { }}>+</button>}
                                                    </div>
                                                        </div>
                                                ))
                                                
                                            };
                                            </div>
                                        </tr>
                                        <tr>

                                            <div style={{
                                                padding: "5px 5px", flex: 1, fontSize: "35px",
                                                display: "flex",
                                                flexDirection: "row", alignItems: "flex-center", justifyContent: "center"
                                            }}>
                                                <button id="validateLibrary" style={{
                                                    margin: "5px 5px", fontSize: "35px",
                                                    color: "#fff", backgroundColor: "darkblue", padding: "5px 5px", borderRadius: "5px"
                                                }}
                                                    onClick={() => window.processLibrary(libraryTags)}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>


                        </tbody>
                    </table>


                    <div
                        id="mapContainer"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: "5px",
                            //alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                paddingLeft: "0px",
                                border: "none",
                                height: "620px",
                                width: "800px",
                                borderRadius: "10px",
                                //backgroundColor: "lightgrey",
                            }}
                            id="map"
                        >
                        </div>

                        <div
                            id="year-slider"
                            style={{
                                display: "none",
                                flexDirection: "row",
                                color: "darkblue",
                                justifyContent: "center",
                                paddingLeft: "20px",
                                border: "none",
                                width: "750px",
                                margin: "10px 0",
                            }}
                        >

                        </div>

                    </div>


                </div>



                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div style={{ visibility: "hidden" }}>
                                    <textarea id="videoInfo" name="videoInfo" rows="1" cols="1">
                                        ...
                                    </textarea>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table style={{ backgroundColor: "white", width: "800px" }}>
                    <tbody>

                        {/* Video box image and text */}
                        <tr style={{ paddingLeft: "0px", border: "none", width: "800px" }}>
                            <div style={{ alignContent: "flex-start", textAlign: "flex-start", display: "flex", flexDirection: "row" }}>
                                <div
                                    id="videoBoxImage"
                                    style={{
                                        //width: "30%",
                                        flex: 0.25,

                                        wordWrap: "break-word",
                                        fontSize: "25px",
                                    }}
                                >

                                </div>
                                <div
                                    id="videoBoxText"
                                    style={{
                                        //width: "70%",
                                        flex: 0.75,
                                        fontFamily: "Arial, sans-serif",
                                        wordWrap: "break-word",
                                        fontSize: "20px",
                                    }}
                                >

                                </div>
                            </div>
                        </tr>
                        <tr style={{ paddingLeft: "0px", border: "none", width: "700px", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>

                            <div
                                id="artistsBox"
                            //style={{
                            //width: "70%",
                            //    flex: 1,
                            //    wordWrap: "break-word",
                            //    fontSize: "20px",
                            //}}
                            >
                            </div>
                        </tr>

                        <tr style={{ textAlign: "center" }}>
                            <td >
                                <button
                                    id="GIFs"
                                    className="button2"
                                    style={{
                                        padding: "5px 5px",
                                        margin: "0px 10px",
                                        fontSize: "25px",
                                        backgroundColor: "darkblue",
                                        color: "#fff",
                                    }}
                                    onClick={() => window.toggleGIFs()}
                                >
                                    GIFs
                                </button>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <div style={{ paddingLeft: "0px" }}>
                    <iframe
                        style={{
                            paddingLeft: "0px",
                            border: "none",
                            height: "800px",
                            width: "800px",
                            display: "none",
                        }}
                        allowFullScreen
                        id="iframe"
                        src="https://www.bing.com/images/search?q=music&form=HDRSC2&first=1&scenario=ImageBasicHover"
                        name="iframe"
                        title="Image Search"
                    ></iframe>
                </div>
            </div >
        </div>
    );
};

export default MyPage;